import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectCardOpenAiDescription } from '../../../../reducers/documentation/documentationCardReducer';

export const useInitializeOpenAiDescriptionForRule = ({
  metadataId,
  crmOrgId,
  shouldDataBeCalled,
  getOpenAiDescriptionForRule,
}: {
  metadataId: string;
  crmOrgId: string;
  shouldDataBeCalled: boolean;
  getOpenAiDescriptionForRule: (args: { crmOrgId: string; metadataId: string }) => Promise<void>;
}) => {
  const openAiDescription = useSelector(selectCardOpenAiDescription(metadataId ?? ''));

  useEffect(() => {
    if (!openAiDescription && metadataId && shouldDataBeCalled) {
      getOpenAiDescriptionForRule({
        crmOrgId,
        metadataId,
      });
    }
  }, [crmOrgId, openAiDescription, getOpenAiDescriptionForRule, shouldDataBeCalled, metadataId]);
};
